<script setup lang="ts">
import { useLanguage } from '../components/composables/useLanguage';
import { ErrorCard } from '../components/elements/ErrorCard';
import ForbiddenViewTopHeader from '../components/elements/ErrorCard/ForbiddenViewTopHeader.vue';

const { t } = useLanguage();

defineProps({
  icon: { type: String, required: true },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' }
});
</script>

<template>
  <div class="flex flex-col items-center justify-center w-full h-dvh">
    <ForbiddenViewTopHeader :title="t('inno_page_title')" />
    <ErrorCard v-bind="{ icon, title, subtitle }" />
  </div>
</template>
